<template>
  <div class=" tailor">
    <nav class="navbar navbar-dark sticky-top" style="background-color: maroon;">
      <a class="navbar-brand" href="#">Add New Comment <i class="fa fa-comments"></i></a>
      <a href="#" class="text-light" v-on:click="resetForm()" v-b-tooltip.hover title="Close">
        <i class="fas fa-2x fa-times-circle"></i>
      </a>
    </nav>
    <br>
    <div class="row container">
      <div class="col">
        Click the "Select Location" button and select a location in the 3D View
        <button v-on:click="addNewCommentLayer()" class="btn btn-primary" title="Click to start adding comments">
        Select Location
        </button>
      </div>
    </div>
    <hr>
    <br>
    <template v-if="isLocationSelected">
      <div class="container">
        <!-- <div class="form-group row" >
          <label class="col-sm-2 col-form-label">Name</label>
          <div class="col-sm-10">
            <input class="form-control" v-model="userName" disabled>
          </div>
        </div> -->
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Comment</label>
          <div class="col-sm-9">
            <textarea style="resize:none;" rows="10" class="form-control" v-model="textComment" required></textarea>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Asset Type</label>
          <div class="col-sm-9">
            <!-- <select class="form-control" v-model="selectedDiscipline" required> -->
            <select class="form-control" v-model="selectedAssetType" required>
              <option value="" disabled selected></option>
              <option v-for="(item, index) in assetTypeList" :key="index" :value="item.code">{{item.label}}</option>
              <!-- <option value="road_design">Road Design</option>
              <option value="bridge">Bridge</option>
              <option value="utility">Utility</option>
              <option value="drainage">Drainage</option>
              <option value="environment">Environment</option>
              <option value="ecology">Ecology</option>
              <option value="heritage">Heritage</option>
              <option value="geotechnical">Geotechnical</option> -->
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Priority</label>
          <div class="col-sm-9">
            <select class="form-control" v-model="selectedPriority" required>
              <option value="" disabled selected></option>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>
        </div>
        <!-- <div class="form-group row">
          <label class="col-sm-3 col-form-label">Due Date</label>
          <div class="col-sm-9">
            <input class="form-control" v-model="dueDate" type="date" required>
          </div>
        </div> -->
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">Email to</label>
          <div class="col-sm-9">
            <!-- <input class="form-control" v-model="selectedEmail" type="email" required> -->
            <Multiselect
              v-model="selectedEmail"
              :options="emailListNew"
              label="label"
              track-by="value"
              placeholder="Email"
              hide-selected
              multiple
              :taggable="true"
              @tag="addTag"
              :disabled="emailListNew.length == 0"
              >
            </Multiselect>
          </div>
        </div>
        <!-- <div class="form-group row">
          <label class="col-sm-3 col-form-label">File Upload</label>
          <div class="col-sm-9">
            <input class="form-control-file" id="fileUpload" type="file" name="attachment">
          </div>
        </div> -->
        <div class="form-group row">
          <label class="col-sm-3 col-form-label">File Upload</label>
          <div class="col-sm-9">
            <b-form-file id="fileUpload"></b-form-file>
          </div>
        </div>

        <br>
        <div class="text-right">
          <button v-on:click="submitNewCommentLayer()" class="btn btn-outline-primary mr-2" title="Click to submit comment">
            Submit
          </button>
          <button v-on:click="resetForm()"
            class="btn btn-outline-danger"
             title="Click to cancel">
            Cancel
          </button>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
/*eslint-disable*/
import { loadModules } from 'esri-loader';
import {baseApiUrl, appBaseUrl} from "../../config.js"
import axios from "axios"
import Multiselect from "vue-multiselect"

export default {
  name: 'NewComment',
  components: {
    Multiselect
  },
  data () {
    return {
      userName: this.$store.state.mapModule.userName,
      textComment: "",
      selectedDiscipline: "",
      selectedAssetType: "",
      selectedPriority: "",
      dueDate: "",
      approvalStatus: "Pending",
      isLocationSelected: false,
      selectedEmail: [],
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      emails: [
        {
          value: "leonardo.quines@arcadis.com",
          label: "leonardo.quines@arcadis.com"
        },
        {
          value: "sheena.verdad@arcadis.com",
          label: "sheena.verdad@arcadis.com"
        },
        {
          value: "Rittick.Borah@arcadis.com",
          label: "Rittick.Borah@arcadis.com"
        },
        {
          value: "Nalin.Senevirathne@arcadis.com",
          label: "Nalin.Senevirathne@arcadis.com"
        }
      ],
      errorMsgDictionary: {
        noCommentFound: "Comment field was left blank",
        noDisciplineFound: "Discipline field was left blank",
        noPriorityFound: "Priority field was left blank",
        noDueDateFound: "Due Date was left blank",
        noEmailFound: "Email to was left blank",
        noAssetTypeFound: "Asset Type field was left blank"
      },
      newCommentGeometry: {
        longitude: null,
        latitude: null,
        z: null
      },
      emailListNew: [
        {
          value: "DEMAssetDelivery@roads.vic.gov.au",
          label: "DEMAssetDelivery@roads.vic.gov.au"
        },
        // this.$store.state.mapModule.currentLoggedUser
      ]
    }
  },
  computed: {
    webscene: {
      get() {
        return this.$store.state.mapModule.mapWebScene
      }
    },
    commentLayerId: {
      get() {
        return this.$store.state.mapModule.staticCommentLayerId
      }
    },
    commentLayerTitle: {
      get() {
        return this.$store.state.mapModule.staticCommentLayerTitle
      }
    },
    disciplineList: {
      get() {
        return this.$store.state.mapModule.disciplineList
      }
    },
    emailList: {
      get() {
        return this.$store.state.mapModule.emailList
      }
    },
    assetTypeList: {
      get() {
        return this.$store.state.mapModule.assetTypeList
      }
    },
    currentLoggedUser: {
      get() {
        return this.$store.state.mapModule.currentLoggedUser
      }
    },
  },
  watch: {
    // webscene: function() {
    //   const current = this
    //   if (current.webscene) {
    //     console.log("current.webscene is true");
    //     current.loadCommentList()
    //   }
    // }
    selectedDiscipline: function() {
      console.log(this.selectedDiscipline);
      const current = this
      current.$store.commit("mapModule/setEmailList", current.selectedDiscipline)
    }
  },
  methods: {
    addTag: function (newTag) {
      console.log(newTag);
      const current = this
      const tag = {
        value: newTag,
        label: newTag
      }
      if (current.reg.test(newTag)) {
        current.emails.push(tag)
        current.selectedEmail.push(tag)
      }
      else {
        current.$notify({
          group: 'errors',
          title: "Error Adding Email",
          type: 'error',
          text: "Email entered is invalid.",
          width: 500,
          duration: 2000
        })
      }
    },
    addNewCommentLayer: function() {
      const scene = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      const current = this
      sceneView.graphics.removeAll()
      console.log(current.webscene);
      loadModules([
        "dojo/on",
        "esri/Graphic"],{ css: true })
      .then(([
        on,
        Graphic]) => {
        var appMap = document.getElementById("map");
        appMap.style.cursor = "crosshair";
        var onceClick = on.once(sceneView, "click", (evt) => {
          if (appMap.style.cursor === "auto") {
            onceClick.remove();
            console.log("event listener removed");
            return;
          }
          sceneView.hitTest(evt).then((hitTestResult) => {
            if (hitTestResult.results.length) {
              var point = hitTestResult.results[0].mapPoint.clone()
            } else {
              var point = hitTestResult.ground.mapPoint.clone()
            }
            point.z = 0
            console.log(point);
            var newCommentEntry = new Graphic({
              geometry: point,
              attributes: {},
              symbol: {
                type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                url: "InitialMarker.png",
                width: 20
                // type: "point-3d",
                // symbolLayers: [{
                //   type: "object",
                //   anchor: "origin",
                //   width: 5,
                //   material: {
                //     color: [0, 132, 168, 1]
                //   }
                // }]
              }
            });
            sceneView.graphics.add(newCommentEntry);
            current.newCommentGeometry.longitude = point.longitude
            current.newCommentGeometry.latitude = point.latitude
            current.newCommentGeometry.z = point.z
            current.isLocationSelected = true
            appMap.style.cursor = "auto";
          })
        })
      })
    },
    saveValidation: function() {
      const current = this
      var errors = []
      if (current.textComment == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Comment"
        errorMessage.errorBody = current.errorMsgDictionary.noCommentFound
        errors.push(errorMessage)
      }
      if (current.selectedAssetType == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Asset Type"
        errorMessage.errorBody = current.errorMsgDictionary.noAssetTypeFound
        errors.push(errorMessage)
      }
      if (current.selectedPriority == "") {
        var errorMessage = {}
        errorMessage.errorTitle = "Priority"
        errorMessage.errorBody = current.errorMsgDictionary.noPriorityFound
        errors.push(errorMessage)
      }
      // if (current.dueDate == "") {
      //   var errorMessage = {}
      //   errorMessage.errorTitle = "Due Date"
      //   errorMessage.errorBody = current.errorMsgDictionary.noDueDateFound
      //   errors.push(errorMessage)
      // }
      if (current.selectedEmail.length == 0) {
        var errorMessage = {}
        errorMessage.errorTitle = "Email"
        errorMessage.errorBody = current.errorMsgDictionary.noEmailFound
        errors.push(errorMessage)
      }
      return errors
    },
    submitNewCommentLayer: function() {
      const current = this
      const vue = document.getElementById("map").__vue__
      const sceneView = vue.view
      var errors = current.saveValidation();
      if (errors.length > 0) {
        errors.forEach(item=>{
          current.$notify({
            group: 'errors',
            title: item.errorTitle,
            type: 'error',
            text: item.errorBody,
            width: 500,
            duration: -1
          })
        })
      }
      else {
        var dateToday = current.getDateToday()
        var fileUploadDom = document.getElementById("fileUpload");
        // var commentSceneLayer = sceneView.map.allLayers.filter(function(item) {
        //   return item.id === current.commentLayerId;
        // }).items[0];
        var commentSceneLayer = sceneView.map.findLayerById(current.commentLayerId)
        var recipients = []
        current.selectedEmail.forEach(item => {
          recipients.push(item.value)
        })
        recipients.push(current.currentLoggedUser.value)
        var data = {
          // disciplineCode: current.selectedDiscipline,
          assetTypeCode: current.selectedAssetType,
          priorityCode: current.selectedPriority,
          approvalStateCode: current.approvalStatus.toLowerCase(),
          longitude: current.newCommentGeometry.longitude,
          latitude: current.newCommentGeometry.latitude,
          elevation: current.newCommentGeometry.z,
          // dueDate: current.dueDate,
          commenterName: current.$store.state.mapModule.userName,
          commentDetails: current.textComment,
          recipients: recipients
        }
        var newCommentURL = baseApiUrl + "saveInitialComment"
        var config  = {
          responseType: 'json'
        }
        axios.post(newCommentURL, data, config).then(response=>{
          // console.log(response);
          // query new Comment list
          sceneView.map.remove(commentSceneLayer);
          sceneView.map.allLayers.refresh()
          console.log("after Refresh");
          current.$store.dispatch("mapModule/fetchCommentLayer").then(currentCommentLayer=>{
            console.log("just fetched the new comment Layer");
            sceneView.map.add(currentCommentLayer);

            console.log(sceneView.map.allLayers);

            // console.log(currentCommentLayer);
            var latestComment = currentCommentLayer.graphics.items[currentCommentLayer.graphics.items.length-1]
            // response.graphics.items.forEach(comment=>{
            var featureObject = {}
            featureObject["objectId"] = latestComment.attributes.id
            // featureObject["globalId"] = latestComment.attributes.globalid
            // featureObject["discipline"] = latestComment.attributes.discipline
            featureObject["assetType"] = latestComment.attributes.assetType
            featureObject["priority"] = latestComment.attributes.priority
            featureObject["name"] = latestComment.attributes.commenterName
            featureObject["comment"] = latestComment.attributes.details
            featureObject["approvalStatus"] = latestComment.attributes.approvalState
            featureObject["date"] = latestComment.attributes.date
            // featureObject["dueDate"] = latestComment.attributes.dueDate

            // current.commentFeatureList.push(featureObject)
            // current.commentIds.push(item.attributes.id)
            // current.$store.commit("mapModule/insertInitialComments", featureObject)
            // var fileUploadDom = document.getElementById("fileUpload");
            current.uploadAttachment(latestComment.attributes.id).then(fileDetail=>{
              console.log("just finished uploading the attachment");
              if (fileDetail.hasFile) {
                featureObject["fileName"] = fileDetail.fileName
                featureObject["fileId"] = fileDetail.fileId
              }
              current.sendEmail(featureObject)
              current.$store.commit("mapModule/insertInitialComments", featureObject)
              console.log(fileDetail);
              current.resetForm()
            })
          })
        })
      }
    },
    OLDsubmitNewCommentLayer: function() {
      const current = this
      var errors = current.saveValidation();
      if (errors.length > 0) {
        errors.forEach(item=>{
          current.$notify({
            group: 'errors',
            title: item.errorTitle,
            type: 'error',
            text: item.errorBody,
            width: 500,
            duration: -1
          })
        })
      }
      else{
        var dateToday = current.getDateToday()

        var appMap = document.getElementById("map");
        var fileUploadDom = document.getElementById("fileUpload");
        var sceneView = appMap.__vue__.view;
        var layerId = '';
        var commentSceneLayer = current.webscene.allLayers.filter(function(item) {
          return item.title === "Comments3DDevelopment";
        }).items[0];
        var newCommentEntry = sceneView.graphics.items[0]
        newCommentEntry.attributes["name"] = current.userName;
        newCommentEntry.attributes["comment"] = current.textComment;
        // newCommentEntry.attributes["discipline"] = current.selectedDiscipline;
        newCommentEntry.attributes["discipline"] = current.selectedDiscipline;
        // newCommentEntry.attributes["duedate"] = current.dueDate;
        newCommentEntry.attributes["date"] = dateToday;
        newCommentEntry.attributes["approvalstatus"] = current.approvalStatus;
        newCommentEntry.attributes["priority"] = current.selectedPriority;
        var edits = {
          addFeatures: [newCommentEntry]
        };
        commentSceneLayer.applyEdits(edits).then((result) => {
          console.log("edits successfully applied");
          console.log(commentSceneLayer);
          var featureObject = {}
          featureObject["objectId"] = result.addFeatureResults[0].objectId
          featureObject["discipline"] = current.selectedDiscipline
          featureObject["priority"] = current.selectedPriority
          featureObject["name"] = current.userName
          featureObject["comment"] = current.textComment
          featureObject["approvalStatus"] = current.approvalStatus
          featureObject["date"] = dateToday
          // featureObject["dueDate"] = current.dueDate
          current.$store.commit("mapModule/insertInitialComments", featureObject)
          current.saveCommentRecipients(featureObject)
          // Sending Email for Initial Comment
          current.sendEmail(featureObject)
          console.log(fileUploadDom.files.length);
          console.log(fileUploadDom.files);
          if (fileUploadDom.files.length == 1) {
            console.log("fileUpload length equal to 1");
            const queryParams = commentSceneLayer.createQuery()
            queryParams.where = "OBJECTID = " + result.addFeatureResults[0].objectId
            commentSceneLayer.queryFeatures(queryParams).then((featureResultItems) => {
              console.log("feature queried");
              var submittedFeature = featureResultItems.features[0]
              console.log(submittedFeature);
              const file = fileUploadDom.files[0];
              console.log(file);
              const fileUpload = new FormData();
              fileUpload.set("attachment", file);
              fileUpload.append("f", "json")
              console.log(fileUpload);
              commentSceneLayer.addAttachment(submittedFeature, fileUpload)
                .then(function(fileUploadResult) {
                  console.log("File Upload Successful");
                  console.log(fileUploadResult);
                  // 1. get attachmentID, create link
                  // 2. edit feature attribute to add attachment link to column
                  // 3. reset Form (NO NEED)
                  current.resetForm()
                  sceneView.graphics.removeAll()
                  sceneView.map.allLayers.remove(commentSceneLayer);
                  sceneView.map.allLayers.add(commentSceneLayer);

                })
                .catch(function(fileUploadError) {
                  console.log("File Upload Failed");
                  console.log(fileUploadError);
                  current.resetForm()
                  sceneView.graphics.removeAll()
                  sceneView.map.allLayers.remove(commentSceneLayer);
                  sceneView.map.allLayers.add(commentSceneLayer);

                })
            })
          }
          else {
            current.resetForm()
            sceneView.graphics.removeAll()
            sceneView.map.allLayers.remove(commentSceneLayer);
            sceneView.map.allLayers.add(commentSceneLayer);
            // cancelButton
          }
        })
      }

    },
    resetForm: function() {
      const current = this
      var view =  document.getElementById("map").__vue__.view
      current.textComment = ""
      current.selectedDiscipline = ""
      current.selectedPriority = ""
      current.dueDate = ""
      current.approvalStatus= "Pending"
      view.graphics.removeAll()
      document.getElementById("addCommentButton").click();
      current.newCommentGeometry = {
        longitude: null,
        latitude: null,
        z: null
      }
      var appMap = document.getElementById("map");
      appMap.style.cursor = "auto";
    },
    sendEmail: function(data) {
      const current = this
      var url = baseApiUrl + "sendEmail"
      var receiverEmail = []
      current.selectedEmail.forEach(item => {
        receiverEmail.push(item.value)
      })
      console.log(current.currentLoggedUser);
      receiverEmail.push(current.currentLoggedUser.value)
      var data = {
        receiveremail: receiverEmail,
        commentid: data.objectId,
        name: data.name,
        comment: data.comment,
        // discipline: data.discipline,
        assetType: data.assetType,
        priority: data.priority,
        // duedate: data.dueDate,
        date: data.date,
        approvalstatus: data.approvalStatus,
        appBaseUrl: appBaseUrl
      }
      var config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        console.log(result.data);
      }).catch((error)=> {
        console.log(error);
      })
    },
    saveCommentRecipients: function(data) {
      const current = this
      var recipients = []
      current.selectedEmail.forEach(item => {
        recipients.push(item.value)
      })
      var data = {
        commentId: data.objectId,
        discipline: data.discipline,
        recipients: recipients
      }
      var url = baseApiUrl + "saveInitialComment"
      var config  = {
        responseType: 'json'
      }
      axios.post(url, data, config).then((result)=>{
        console.log("saved");
      }).catch(error=>{
        console.log(error)
      })
    },
    getDateToday: function() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time = hours + ":" + minutes + ":" + seconds + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
    deprecated_resetCommentsList: function(current) {
      return new Promise(function(resolve, reject) {
        var url = baseApiUrl+"fetchComments"
        var data = {}
        var config = {
          responseType: 'json'
        }
        axios.post(url, data, config).then(response=>{
          var commentsList = response.data.features
          console.log(commentsList);
          var commentsCount = 0;
          loadModules([
            "esri/layers/GraphicsLayer",
            "esri/Graphic"
          ],{ css: true })
          .then(([
            GraphicsLayer,
            Graphic
          ]) => {
            const commentGraphicsLayer = new GraphicsLayer({
              id: current.commentLayerId
            });
            for (const comment of commentsList) {
              // if (++commentsCount > 1) {
              //   break
              // }
              // create graphic, add to graphicslayer
              var commentEntry = new Graphic({
                geometry: {
                  type: "point",
                  latitude: comment.geometry.latitude,
                  longitude:comment.geometry.longitude,
                  z: comment.geometry.height
                },
                attributes: comment.attributes,
                symbol: {
                  type: "point-3d",
                  symbolLayers: [{
                    type: "object",
                    anchor: "origin",
                    width: 5,
                    material: {
                      color: [0, 132, 168, 1]
                    }
                  }]
                }
              });
              commentGraphicsLayer.graphics.push(commentEntry)
            }
            resolve(commentGraphicsLayer)
          })
        })
      });
    },
    uploadAttachment: function(commentId) {
      return new Promise(function(resolve, reject) {
        var attachmentsSuccessfulCount = 0
        var fileUploadDom = document.getElementById("fileUpload");
        console.log(fileUploadDom);
        if (fileUploadDom.files.length === 1) {
          var fileURL = baseApiUrl + "addCommentAttachment"
          fileUploadDom.files.forEach(item=>{

            var fileData = new FormData();
            fileData.append("fileinput"       , item);
            fileData.append("commentId"       , commentId);
            fileData.append("filename"        , item.name);
            fileData.append("filetype"        , item.type);
            var fileConfig = {
              headers: {
                'content-type': 'application/octet-stream'
              },
              responseType: 'json'
            }
            axios.post(fileURL, fileData, fileConfig).then(fileResult=>{
              // result.data.replyAttachments.push(fileResult.data)
              fileResult.data.hasFile = true
              resolve(fileResult.data)
              // attachmentsSuccessfulCount+=1
              // if (attachmentsSuccessfulCount==current.replyAttachments.length) {
              // }
            })
            .catch(error=>{
              console.log(error);
            })
          })
        }
        else {
          resolve(
            {
              hasFile:false
            }
          )
        }

      });
    }
  },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .tailor {
    height: 912px;
    max-height: 99%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .multiselect__tag {
    background: gray !important;
    color: white !important;
  }
  .multiselect__tag-icon {
    background: gray !important;
    color: white !important;
  }
  .multiselect__tag-icon:after {
    color: white !important;
  }
  .multiselect__option--highlight {
    background: gray !important;
    outline: none;
    color: white;
  }
  .multiselect__option--highlight:after {
    background: gray !important;
  }
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px;
  }
</style>
